import { ReviewsPhoto, ReviewsResponse } from '../types';
import { convertReviewsPhoto } from './response-processor';

export const extractReviewsAllPhotos = (data: ReviewsResponse): ReviewsPhoto[] => {
  let result: ReviewsPhoto[] = [];
  if (data.product.review_photos instanceof Array) {
    try {
      result = data.product.review_photos.map(convertReviewsPhoto);
    } catch {
      result = [];
    }
  }

  return result;
};
